import React from "react"
import {BottomSheet} from "../../libs/react-spring-bottom-sheet";
import {DynamicIcon} from "lucide-react/dynamic";
import {ActionSheetContext} from "../providers/ActionSheetProvider";
import { isMobileApp, MOBCOLORS } from '../../configs/AppConfig';
import OffCanvas, { OffCanvasBody, OffCanvasHeader } from '../../components/bootstrap/OffCanvas';


class SheetComponent extends React.Component
{

    state={
        sheetProps:{
            height:0.9
        }
    }

    constructor(props) {
        super(props);
    }

    renderDesktop()
    {
        const sheetContext=this.props.sheetContext
        const payload=sheetContext.getPayload()

        return(
            <OffCanvas
                isOpen={this.props.open}
                setOpen={()=> {
                    sheetContext.cancel()
                }}
                placement={"end"}
                isBodyScroll={false}
                isBackdrop={true}
            >
                <OffCanvasHeader setOpen={()=>sheetContext.cancel()}>
                    {payload?.closeText &&(
                        <div style={{display:"flex",flexDirection:"column",gap:5,marginBottom:10}}>
                            <div style={{display:"flex",alignItems:"center",justifyContent:"flex-start",width:'100%',padding:"0 2.5%"}}>
                                    <span style={{display:"flex",flex:1,alignItems:"center",fontSize:15,color:MOBCOLORS.blue.color,textDecorationLine:"underline",cursor:"pointer"}} onClick={()=>{
                                        sheetContext.close()
                                    }}>
                                        <DynamicIcon name={"chevron-left"} color={MOBCOLORS.blue.color} size={18} />
                                       <span style={{maxWidth:"80vw",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{payload.closeText}</span>
                                    </span>
                            </div>
                        </div>
                    )}
                </OffCanvasHeader>

                <OffCanvasBody>
                    <div style={{display:"flex",flex:1,flexDirection:"column",padding:"0 5%"}}>
                        {this.props.open && this.renderContent && this.renderContent()}
                    </div>
                </OffCanvasBody>
            </OffCanvas>
        )
    }

    renderMobile(actionSheetContext)
    {
        const sheetContext=this.props.sheetContext
        const payload=sheetContext.getPayload()
        const bottomInset=window?.safeAreaInsets?.bottom || 0

        return(
            <BottomSheet
                open={this.props.open}
                onDismiss={()=> {
                    sheetContext.cancel()
                }}
                //snapPoints={({ minHeight, maxHeight }) => [maxHeight * 0.3,maxHeight * 0.6,maxHeight * 0.9]}
                snapPoints={({ minHeight, maxHeight }) => [maxHeight * this.state.sheetProps.height]}
                defaultSnap={({ lastSnap, snapPoints }) => snapPoints[snapPoints.length-1]}
                expandOnContentDrag={true}
                //blocking={!actionSheetContext.isOpened}

                {...this.state.sheetProps}
            >

                {payload?.closeText &&(
                    <div style={{display:"flex",flexDirection:"column",gap:5,marginBottom:10}}>
                        <div style={{display:"flex",alignItems:"center",justifyContent:"flex-start",width:'100%',padding:"0 2.5%"}}>
                                        <span style={{display:"flex",flex:1,alignItems:"center",fontSize:15,color:MOBCOLORS.blue.color,textDecorationLine:"underline",cursor:"pointer"}} onClick={()=>{
                                            sheetContext.close()
                                        }}>
                                            <DynamicIcon name={"chevron-left"} color={MOBCOLORS.blue.color} size={18} />
                                           <span style={{maxWidth:"80vw",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{payload.closeText}</span>
                                        </span>
                        </div>
                    </div>
                )}


                <div style={{display:"flex",flex:1,flexDirection:"column",padding:"0 5%",paddingBottom:20+bottomInset}}>
                    {this.props.open && this.renderContent && this.renderContent()}
                </div>
            </BottomSheet>
        )
    }

    render()
    {
        return(
            <ActionSheetContext.Consumer>
                {(actionSheetContext)=>{
                    if(isMobileApp){
                        return this.renderMobile(actionSheetContext);
                    }
                    return this.renderDesktop(actionSheetContext);
                }}
            </ActionSheetContext.Consumer>
        )
    }
}

export default SheetComponent
